/** Bounds (ms) of the random jitter added to periodic refetch intervals. */
const MIN_REFETCH_JITTER_MS = 1_000; // 1s
const MAX_REFETCH_JITTER_MS = 20_000; // 20s

/**
 * Returns a random 1–20s (in ms) to add on top of a periodic refetch interval. Spreading the
 * interval per widget/instance keeps refetches from all firing on the same tick, avoiding a
 * synchronized burst of requests to the backend (thundering herd).
 */
export const getRefetchJitterMs = (): number =>
  MIN_REFETCH_JITTER_MS + Math.random() * (MAX_REFETCH_JITTER_MS - MIN_REFETCH_JITTER_MS);

/** Bounds (ms) of the random pause between the steps of a sequential request walk. */
const MIN_SEQUENTIAL_STEP_JITTER_MS = 200;
const MAX_SEQUENTIAL_STEP_JITTER_MS = 1_000; // 1s

/**
 * Returns a random 0.2–1s (in ms) to wait before a sequential walk sends its next request, so two
 * viewers who opened the same widget together drift apart instead of hitting the API in lockstep.
 * Far shorter than the refetch jitter: a walk pauses once per request, and a site's heatmap is
 * pens × weeks requests long.
 */
export const getSequentialStepJitterMs = (): number =>
  MIN_SEQUENTIAL_STEP_JITTER_MS +
  Math.random() * (MAX_SEQUENTIAL_STEP_JITTER_MS - MIN_SEQUENTIAL_STEP_JITTER_MS);
